<script lang="ts">
    import { users } from "../../../store"

    export let task: Task
    interface ProtocolOverview {
        [user: string]: {
            completedSteps: number[]
        }
    }
    let protocolOverview: ProtocolOverview = {}
    ;(task?.meta?.editedBy || []).forEach((user) => {
        if (!protocolOverview[user.id]) {
            protocolOverview[user.id] = {
                completedSteps: [],
            }
        }
    })
    ;(task.completedSteps || []).forEach((step) => {
        if (!protocolOverview[step.completedBy]) {
            protocolOverview[step.completedBy] = {
                completedSteps: [],
            }
        }
        protocolOverview[step.completedBy].completedSteps.push(step.stepNr)
    })

    const amountOfSteps = task.taskType === "oilSpillRemoval" ? 8 : 2
</script>

<ul class="task-steps-completed-by">
    {#if Object.keys(protocolOverview).length === 0}
        <p>Niemand hat diesen Einsatz bisher bearbeitet.</p>
    {:else}
        {#each Object.keys(protocolOverview) as user}
            <li>
                <div>
                    <p>{$users[user]?.username || "Unbekannt"}</p>
                    <ul class="task-steps-completed">
                        {#each Array.from({ length: amountOfSteps }, (_, i) => i + 1) as step}
                            <li class:active="{(protocolOverview[user].completedSteps || []).includes(step)}">
                                {step}
                            </li>
                        {/each}
                    </ul>
                </div>
            </li>
        {/each}
    {/if}
</ul>

<style lang="less">
    .task-steps-completed-by {
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        & > li {
            div {
                border-radius: 48px;
                border: 1px solid var(--text-200);

                padding: 0.4rem 1.2rem;
                display: flex;
                gap: 1.2rem;
                justify-content: space-between;
                align-items: center;
                p {
                    text-transform: uppercase;
                }
                & > ul {
                    display: flex;
                    gap: 2px;
                    & > li {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 1.2rem;
                        height: 1.2rem;
                        border-radius: 1.2rem;
                        border: 2px solid var(--white-100);
                        color: white;
                        background: var(--text-100);
                        font-family: Inter-Bold;
                        font-size: 0.8rem;
                        &.active {
                            background: var(--confirm-100);
                        }
                    }
                }
            }
        }
    }
</style>
